import React, { useState } from 'react';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import AddressDisplay from './AddressDisplay';
import ShippingForm from './Form';
import styles from './ShippingAddress.module.scss';

function ShippingAddress() {
  const {
    viewSize, setShowPaymentForm,
  } = useAppContext();
  const [showForm, setShowForm] = useState(true);
  const [transitionStyle, setTransitionStyle] = useState('900px');
  const slideFormDown = () => {
    setTransitionStyle('900px');
    setShowForm(true);
  };
  const slideFormUp = () => {
    // this is to wait for AddressVerification to finish its last render
    setTimeout(() => {
      setTransitionStyle('0');
      setTimeout(() => {
        setShowForm(!showForm);
        setShowPaymentForm(true);
      }, 1000);
    }, 500);
  };
  return (
    <>
      <div className={`${styles.shippingAddress} ${viewSize}`}>
        <div className={styles.headerContainer}>
          <p className={styles.header}>Add Shipping Information</p>
          {!showForm && <div className={styles.buttonContainer}><button className={styles.editButton} type="button" onClick={slideFormDown} onKeyPress={slideFormDown}>Edit</button></div>}
        </div>
        <div className={styles.divider} />
        {showForm
          && (
          <div className={styles.form} style={{ maxHeight: transitionStyle }}>
            <p className={styles.subHeader}>
              Tell us where to ship your products if you decide to purchase anything.
            </p>
            <ShippingForm slideFormUp={slideFormUp} />
          </div>
          )}
        {!showForm && (
          <>
            <AddressDisplay />
          </>
        )}
      </div>
    </>
  );
}

export default ShippingAddress;
